<template>
    <v-app style="background: transparent;" id="contact">
        <div class="contact">
            <!-- <h1>Let's <span>Talk</span></h1> -->
            <div class="contact-container">
                <div class="row">
                    <div class="contact-left">
                        <h1 class="sub-title">Contact <span>me</span></h1>
                        <div class="info">
                            <p><fa :icon="['fas', 'user']" class="info-icon"/>Keerthikanth Rohit</p>
                            <p><fa :icon="['fas', 'paper-plane']" class="info-icon" />rohitkeerthikanth@gmail.com</p>
                        </div>
                        <div class="social-media">
                            <a href="https://www.instagram.com/_rohit_kk_/" target="_blank"><fa :icon="['fab', 'instagram']"/></a>
                            <a href="https://www.linkedin.com/in/keerthikanth-rohit-a-794506251/" target="_blank"><fa :icon="['fab', 'linkedin']" /></a>
                            <a href="https://discordapp.com/users/843176213090140182" target="_blank"><fa :icon="['fab', 'discord']" /></a>
                            <a href="https://github.com/Rohit-KK15" target="_blank"><fa :icon="['fab', 'github']" /></a>
                        </div>
                    </div>
                    <div class="contact-right">
                        <form name="contact" method="post" netlify-honeypot="bot-field" netlify>
                            <p style="display: none;" class="hidden">
                              <label>Dont fill out this if you are Human: <input name="bot-field"></label>
                            </p>
                            <input type="hidden" name="form-name" value="contact" />
                            <div class="input-group">
                                <input v-model="form.name" type="text" name="name" class="input" required>
                                <label for="name" class="label">Name</label>
                            </div>
                            <div class="input-group">
                                <input v-model="form.email" type="text" name="email" class="input" required>
                                <label for="email" class="label">Email</label>
                            </div>
                            <div class="input-group">
                                <textarea v-model="form.message" name="message" rows="6" class="inputL" placeholder="Your Message"></textarea>
                            </div>
                            <button type="submit">submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <footer>
        <p>Designed & Built by <span>RohitKK</span></p>
    </footer>
    </v-app>
</template>


<script>
export default{
    data: ()=> ({
        form: {
            name: '',
            email: '',
            message: ''
        }
    }),
    methods:{
        encode(data){
            return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join('&')
        },
        handleSubmit(){
            fetch('/',{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-urlencoded'
                },
                body: this.encode({
                    'form-name': 'contact',
                    ...this.form
                })
            })
            .then(()=> console.log("successfully sent"))
        }
    }
}
</script>

<style scoped>
footer{
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    bottom: 0;
    position: absolute;
    font-family: 'Poppins';
    height: 60px;
    width: 100%;
    backdrop-filter: blur(8px);
    box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.5);
}

footer p{
    color: #fff;
}
footer p span{
    color: #4C55F7;
    font-size: 20px;
    font-family: bigOver;
}

#contact{
    height: min-content;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins';
}

.contact{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
    flex-direction: column;
}

.contact h1{
    color: #fff;
    font-size: 3rem;
}

.contact h1 span{
    color: #4C55F7;
}

.contact .contact-container{
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-top: 100px; */
    margin-left: 10%;
    margin-right: 10%;
    padding: 1rem 2rem 0 2rem;
    border-top: 2px solid #5c5c5cc3;
    /* border: 2px solid #3f3f3f; */
    /* border: 2px solid #5c5c5cc3;
    border-radius: 30px; */
    flex-wrap: wrap;
}

.contact .contact-container .row{
    display: flex;
    flex-direction: row;
    gap: 30vw;
    /* flex-wrap: wrap; */
}

.contact-left{
    margin-top: 30px;
    flex-basis: 40%;
    width: max-content;
}
.contact-right{
    margin-top: 30px;
    flex-basis: 60%;
}

.contact-left h1{
    font-size: 2.8rem;
    color: #fff;
    border-bottom: 5px solid #4C55F7;
    width: fit-content;
}

.contact-left h1 span{
    color: #4C55F7;
}

/* .contact-left .info{
    margin-top: 50px; 
} */

.contact-left .info p{
    color: #fff;
    margin-top: 30px;
}

.contact-left .info p .info-icon{
    color: #4C55F7;
    margin-right: 15px;
    font-size: 25px;
}

.social-media{
    margin-top: 30px;
}

.social-media a{
    text-decoration: none;
    margin-right: 25px;
    font-size: 35px;
    color: white;
    display: inline-block;
    transition: transform .5s;
}

.social-media a:hover{
    color: #4C55F7;
    /* font-size: 35px; */
    transform: translateY(-5px);
}

.contact-right form{
    width: 100%;

}

form input, form textarea{
    width: 100%;
    border: 0;
    outline: none;
    background: #99999935;
    padding: 15px;
    margin: 15px 0;
    color: #fff;
    font-size: 18px;
    border-radius: 10px;
}

.input-group{
    position: relative;
    width: 450px;
}

.input{
    color: #fff;
    padding: 10px;
    border: none;
    border-radius: 10px;
    outline: 2px solid transparent;
    background-color: #99999935;
    transition: outline-color 500ms;
}
.inputL{
    color: #fff;
    padding: 10px;
    border: none;
    border-radius: 10px;
    outline: 2px solid transparent;
    background-color: #99999935;
    transition: outline-color 500ms;
}

.input:focus,.inputL:focus{
    outline-color: #4C55F7;
}

.input:valid{
    outline-color: #4C55F7;
}

.label{
    position: absolute;
    top: 0;
    left: 0;
    translate: 10px 25px;
    color: #999999;
    transition: translate 500ms, scale 500ms, color 500ms;
}

.input:focus + .label{
    padding-inline: 5px;
    translate: 10px 3px;
    scale: 0.8;
    color: #fff;
    background-color: transparent;
}

.input:valid + .label{
    padding-inline: 5px;
    translate: 10px 3px;
    scale: 0.8;
    color: #fff;
    background-color: transparent;
}


button,
button:after {
  width: 150px;
  height: 46px;
  line-height: 48px;
  font-size: 18px;
  font-family: 'Bebas Neue', sans-serif;
  background: linear-gradient(45deg, transparent 5%, #4C55F7 5%);
  border: 0;
  color: #fff;
  letter-spacing: 3px;
  box-shadow: 6px 0px 0px #00E6F6;
  outline: transparent;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

button:after {
  --slice-0: inset(50% 50% 50% 50%);
  --slice-1: inset(80% -6px 0 0);
  --slice-2: inset(50% -6px 30% 0);
  --slice-3: inset(10% -6px 85% 0);
  --slice-4: inset(40% -6px 43% 0);
  --slice-5: inset(80% -6px 5% 0);
  
  content: 'Submit';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 3%, #00E6F6 3%, #00E6F6 5%, #16194d 5%);
  text-shadow: -3px -3px 0px #f80505, 3px 3px 0px #00E6F6;
  clip-path: var(--slice-0);
}

button:hover:after {
  animation: 1s glitch;
  animation-timing-function: steps(2, end);
}

@keyframes glitch {
  0% {
    clip-path: var(--slice-1);
    transform: translate(-20px, -10px);
  }
  10% {
    clip-path: var(--slice-3);
    transform: translate(10px, 10px);
  }
  20% {
    clip-path: var(--slice-1);
    transform: translate(-10px, 10px);
  }
  30% {
    clip-path: var(--slice-3);
    transform: translate(0px, 5px);
  }
  40% {
    clip-path: var(--slice-2);
    transform: translate(-5px, 0px);
  }
  50% {
    clip-path: var(--slice-3);
    transform: translate(5px, 0px);
  }
  60% {
    clip-path: var(--slice-4);
    transform: translate(5px, 10px);
  }
  70% {
    clip-path: var(--slice-2);
    transform: translate(-10px, 10px);
  }
  80% {
    clip-path: var(--slice-5);
    transform: translate(20px, -10px);
  }
  90% {
    clip-path: var(--slice-1);
    transform: translate(-10px, 0px);
  }
  100% {
    clip-path: var(--slice-1);
    transform: translate(0);
  }
}

@media (min-width: 768px) {
  button,
  button:after {
    width: 200px;
    height: 46px;
    line-height: 48px;
  }
}








@media only screen and (max-width: 600px){


    footer{
        position: relative;
        margin-top: 20px;
    }

    .contact{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

    .contact h1{
    color: #fff;
    font-size: 2.3rem;
}

.contact .contact-container{
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-top: 100px; */
    margin-left: 15%;
    margin-right: 15%;
    padding: 20px;
    /* border: 2px solid #3f3f3f; */
    border-top: 4px solid #999999c3;
    border-bottom: transparent;
    border-left: transparent;
    border-right: transparent;
    border-radius: 20px;
}

    .contact .contact-container .row{
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

    .contact-right, .contact-left{
        flex-basis: 100%;
    }

    form input, form textarea{
    width: 100%;
    border: 0;
    outline: none;
    background: #99999935;
    padding: 15px;
    margin: 15px 0;
    color: #fff;
    font-size: 15px;
    border-radius: 10px;
}

.input-group{
    position: relative;
    width: 300px;
}
}


</style>